app.declineRecovery = {};
// TODO: review all external calls to theses functions and fix
function refreshDetalsScroller() {
	if (app.quickDepositScroll) {
		setTimeout(function () {
			app.quickDepositScroll.refresh();
		}, 150);
	}
}
function suggestMyMethod(selectedUserPaymentOptionId, metaInfo) {
	var pmName = app._upoList[selectedUserPaymentOptionId].paymentOptionName;
	$.extend(true, metaInfo, {uniqueId: selectedUserPaymentOptionId});
	pubsub.publish('app.event.drSelectPm', [{'paymentMethodDR': pmName, metaInfo: metaInfo}]);
	var data = {uniqueId : selectedUserPaymentOptionId, type : 'int', manual: true};
	pubsub.publish('dr-select-pm', [data]);
	sendPostMessageDr(data);
	refreshDetalsScroller();
}
app.declineRecovery.suggestMyMethod = suggestMyMethod; //decline.recovery.my.methods.try.different

function suggestAddNewCard(metaInfo) {
	$.extend(true, metaInfo, {uniqueId: 'cc_card'});
	pubsub.publish('app.event.drSelectPm', [{'paymentMethodDR': 'cc_card', metaInfo: metaInfo}]);
	var data = {uniqueId : 'cc_card', type : 'string', manual: true};
	pubsub.publish('dr-select-pm', [data]);
	sendPostMessageDr(data);
	refreshDetalsScroller();
}
app.declineRecovery.suggestAddNewCard = suggestAddNewCard;// decline.recovery.try.another.card

function suggestOtherPaymentMethod(elm, paymentMethod, metaInfo) {
	$.extend(true, metaInfo, {uniqueId: paymentMethod});
	pubsub.publish('app.event.drSelectPm', [{'paymentMethodDR': paymentMethod, metaInfo: metaInfo}]);
	var data = {uniqueId : paymentMethod, type : 'string', manual: true};
	pubsub.publish('dr-select-pm', [data]);
	sendPostMessageDr(data);
	refreshDetalsScroller();
}

function sendPostMessageDr(data){
    if(data.type === "string"){
        app.util.sendPostMessage({'paymentMethodDR':[data.uniqueId]});
    }
    if(data.type === "int"){
        var pmName = app._upoList[data.uniqueId].paymentOptionName;
        app.util.sendPostMessage({'paymentMethodDR':[pmName]});
    }
};


app.declineRecovery.suggestOtherPaymentMethod = suggestOtherPaymentMethod; //decline.recovery.apms.try.different

function lowerOpenAmount(lowerValue, metaInfo) {
	pubsub.publish('app.event.drLowerOpenAmount', [{lowerValue: lowerValue, metaInfo: metaInfo}]);
	app.util.setAmountValue(lowerValue, ['change']);
}

app.declineRecovery.lowerOpenAmount = lowerOpenAmount;

app.declineRecovery.tryAgain = function tryAgain(metaInfo) {
	// no real action (analytics only)
	pubsub.publish('app.event.drTryAgain', [{metaInfo: metaInfo}]);
};

app.declineRecovery.tryAnotherPm = function(metaInfo) {
	// for analitics
	pubsub.publish('app.event.drTryAnotherPm', [{metaInfo: metaInfo}]);
};

app.declineRecovery.contactIssuerBank = function(metaInfo) {
	pubsub.publish('app.event.drContactIssuerBank', [{metaInfo: metaInfo}]);
	app.util.sendPostMessage({
		"action": "analytics",
		"payload": {
			"action": "dr_contact_issuer_bank",
			"trigger": "user_click_dr_contact_issuer_bank",
			"intent": "dr_contact_issuer_bank",
			"description": "decline recovery contact issuer bank"
		}
	});
};

app.declineRecovery.redirectToUrl = function(url, metaInfo) {
	pubsub.publish('app.event.drRedirectToUrl', [{metaInfo: metaInfo}]);
	window.open(url, '_blank');
};